import { defineMessages } from 'react-intl'

const translations = defineMessages({
  model: {
    defaultMessage: 'Model',
    id: 'msp.account.machine_display.model'
  },
  purchaseDate: {
    defaultMessage: 'Purchase date',
    id: 'msp.account.machine_display.purchase_date'
  },
  serialNumber: {
    defaultMessage: 'Serial number',
    id: 'msp.account.machine_display.serial_number'
  },
  warranty: {
    defaultMessage: 'Warranty',
    id: 'msp.account.machine_display.warranty_label'
  },
  warrantyExpiration: {
    defaultMessage: 'Till {expiryDate}',
    id: 'msp.account.machine_display.warranty_expiry_date'
  }
})

export default translations
